import { CitationData, CitationSourceEnum, Contributor, IDate } from 'src/citation-generator/types';
import { EditFormAction, FormValueKeys, SetErrorAndWarningPayload } from './types';
import * as actionNames from './actionsNames';
import { getBackwardsCompatibleData, keyToAction } from './utils';

export const setSourceType = (v: CitationSourceEnum): EditFormAction => ({
  type: actionNames.SetSourceType,
  payload: v,
});

export const setTitle = (v: string): EditFormAction => ({
  type: actionNames.SetTitle,
  payload: v,
});

export const setTextValueOf = (key: FormValueKeys, v: any): EditFormAction => ({
  type: keyToAction(key),
  payload: v,
});

export const updateContributor = (index: number, value: Contributor): EditFormAction => ({
  type: actionNames.UpdateContributor,
  payload: {
    index,
    value,
  },
});

export const setContributors = (v: Contributor[]): EditFormAction => ({
  type: actionNames.SetContributors,
  payload: v,
});

export const setAccessDate = (date: IDate): EditFormAction => ({
  type: actionNames.SetAccessDate,
  payload: date,
});

export const setPublishDate = (date: IDate): EditFormAction => ({
  type: actionNames.SetPublishDate,
  payload: date,
});

export const resetState = (): EditFormAction => ({
  type: actionNames.ResetState,
});

export const initialize = (citationData?: CitationData): EditFormAction => {
  if (citationData) {
    citationData = getBackwardsCompatibleData(citationData);
  }

  return {
    type: actionNames.Initialize,
    payload: citationData || undefined,
  };
};

export const setErrorAndWarning = (payload: SetErrorAndWarningPayload): EditFormAction => ({
  type: actionNames.SetErrorAndWarning,
  payload,
});

export type TextFieldSetterFn = typeof setTitle;
